import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button, Dropdown, DropdownToggle } from "reactstrap";
import { fetchUserAttributes } from "aws-amplify/auth";

// Images
import logoSm from "../assets/images/BeaconLogo.png";
import logoDark from "../assets/images/BeaconLogo.png";
import logoLight from "../assets/images/BeaconLogo.png";

// Components
import ProfileDropdown from "../Components/Common/ProfileDropdown";

const Header = ({ headerClass = "" }) => {
  const [emailVerified, setEmailVerified] = useState(true);
  const [showAlert, setShowAlert] = useState(true);
  const [search, setSearch] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Auto sync with route
  const isDocumentView = location.pathname === "/documents";

  const toggleSearch = () => setSearch(!search);

  useEffect(() => {
    const getEmailStatus = async () => {
      try {
        const attributes = await fetchUserAttributes();
        setEmailVerified(attributes.email_verified === "true" || attributes.email_verified === true);
      } catch (error) {
        console.error("Failed to fetch user attributes", error);
      }
    };

    getEmailStatus();
  }, []);

  const navigateTo = (type) => {
    navigate(type === "document" ? "/documents" : "/");
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            {/* Left section */}
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="Beacon Logo" height="30" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="Beacon Logo" height="35" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="Beacon Logo" height="30" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="Beacon Logo" height="20" />
                  </span>
                </Link>
              </div>
            </div>

            {/* Email verification alert */}
            {!emailVerified && showAlert && (
              <div
                className="alert alert-warning alert-border-left alert-dismissible fade show w-70 mt-2"
                role="alert"
              >
                <i className="ri-alert-line me-3 align-middle" />
                <strong>Warning</strong> — Your email is not verified.
                <Link
                  to="/verify-email"
                  className="ms-2 text-decoration-underline"
                  onClick={() => setShowAlert(false)}
                >
                  Click here to verify
                </Link>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowAlert(false)}
                />
              </div>
            )}

            {/* Right section */}
            <div className="d-flex align-items-center">
              <Dropdown
                isOpen={search}
                toggle={toggleSearch}
                className="d-md-none topbar-head-dropdown header-item"
              >
                <DropdownToggle
                  tag="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                />
              </Dropdown>

              {isDocumentView ? (
                <Button
                  color="primary"
                  className="btn btn-sm px-3 fs-12"
                  onClick={() => navigateTo("chat")}
                >
                  ChatBot
                </Button>
              ) : (
                <Button
                  color="primary"
                  className="btn btn-sm px-3 fs-12"
                  onClick={() => navigateTo("document")}
                >
                  Knowledge Base
                </Button>
              )}

              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
